<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M17.67 2.98H2.33C1.592 2.98 1 3.596 1 4.353v11.255c0 .757.592 1.372 1.33 1.372h15.34c.733 0 1.33-.615 1.33-1.372V4.353c0-.757-.597-1.373-1.33-1.373m-.224 7.863H15.58c-1.723 0-3.294.832-4.506 2.096l-.014.014a1.47 1.47 0 0 1-1.061.456c-.415 0-.788-.174-1.062-.456l-.013-.014c-1.212-1.264-2.784-2.096-4.506-2.096H2.549V9.569c0-.352.282-.648.629-.648h13.64c.346 0 .628.296.628.648zm.005-4.507H2.549V5.062a.64.64 0 0 1 .633-.648h13.64a.64.64 0 0 1 .629.648z"
	/>
</svg>
